import { IChingCoinFace, IChingLineValue } from '../core/iching.models';

const LINE_VALUES: readonly number[] = [6, 7, 8, 9];

/**
 * Leest de bewaarde worp ("8,8,9,8,7,8", onder naar boven) terug als lijnwaarden.
 * Alles wat geen zes geldige waarden (6..9) oplevert, geeft een lege lijst.
 */
export function parseLines(lines: string | null | undefined): IChingLineValue[] {
  if (!lines) return [];
  const values = lines.split(',').map(part => Number(part.trim()));
  if (values.length !== 6) return [];
  if (values.some(value => !LINE_VALUES.includes(value))) return [];
  return values as IChingLineValue[];
}

/**
 * Leest de bewaarde muntzijden ("HHT,TTT,...", per worp onder naar boven; H = kop, T = munt)
 * terug. Alleen exact zes groepen van drie geldige letters tellen; anders een lege lijst.
 */
export function parseCoinFaces(
  coinFaces: string | null | undefined,
): Array<[IChingCoinFace, IChingCoinFace, IChingCoinFace]> {
  if (!coinFaces) return [];
  const groups = coinFaces.split(',').map(group => group.trim().toUpperCase());
  if (groups.length !== 6 || groups.some(group => !/^[HT]{3}$/.test(group))) return [];
  return groups.map(group => [...group].map(letter => (letter === 'H' ? 'head' : 'tail')) as [IChingCoinFace, IChingCoinFace, IChingCoinFace]);
}
